import { render, staticRenderFns } from "./Menus.vue?vue&type=template&id=48c02efa"
import script from "./Menus.vue?vue&type=script&lang=ts"
export * from "./Menus.vue?vue&type=script&lang=ts"
import style0 from "./Menus.vue?vue&type=style&index=0&id=48c02efa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports